import { usePageSEO } from '@/hooks/usePageSEO';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import PourquoiNous from './components/PourquoiNous';
import ProcessTimeline from './components/ProcessTimeline';
import Garanties from './components/Garanties';
import TemoignagesRapides from './components/TemoignagesRapides';
import FAQ from './components/FAQ';
import QuoteForm from './components/QuoteForm';
import CTAFinal from './components/CTAFinal';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Accueil', item: 'https://couvreur-levis.com/' },
    { '@type': 'ListItem', position: 2, name: 'Soumission gratuite', item: 'https://couvreur-levis.com/soumission-gratuite' },
  ],
};

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Soumission de toiture',
  provider: { '@type': 'LocalBusiness', '@id': 'https://couvreur-levis.com/#business' },
  areaServed: { '@type': 'City', name: 'Lévis' },
  description: "Soumission gratuite de toiture à Lévis en 2h ouvrables. Sans engagement, prix détaillé par poste.",
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'La soumission est-elle vraiment gratuite ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Oui, à 100%. L'inspection sur place, la consultation et la soumission détaillée par courriel sont entièrement gratuits. Vous n'avez rien à payer tant que vous n'avez pas signé de contrat de travail. On n'impose aucun frais caché.",
      },
    },
    {
      '@type': 'Question',
      name: "Suis-je obligé d'accepter après inspection ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Non. Jamais. L'inspection et la soumission sont sans engagement. Vous recevez le document, vous prenez votre temps pour comparer, et vous décidez quand vous êtes prêt. Aucun représentant ne vous harcèlera au téléphone. C'est promis.",
      },
    },
    {
      '@type': 'Question',
      name: 'Combien de temps est valide la soumission ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Nos soumissions sont valides pendant 90 jours. Cela vous donne le temps de comparer, de planifier votre budget ou d'attendre la bonne saison. Si les prix des matériaux changent significativement, on vous en avise et on ajuste ensemble.",
      },
    },
    {
      '@type': 'Question',
      name: 'Travaillez-vous sur ma rue à Lévis ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "On couvre tout Lévis et les secteurs avoisinants : Saint-Nicolas, Saint-Romuald, Charny, Pintendre, Desjardins. Si vous habitez dans la grande région de Lévis, on passe. Appelez-nous pour confirmer — on vous dira honnêtement si on peut se déplacer.",
      },
    },
  ],
};

export default function SoumissionPage() {
  usePageSEO({
    title: 'Soumission gratuite Lévis | Couvreur en 2h | Sans engagement',
    description: 'Obtenez votre soumission gratuite de couvreur à Lévis en 2h ouvrables. Sans engagement, prix détaillé. Appelez le 418-476-9950.',
    urlPath: '/soumission-gratuite',
    keywords: 'soumission gratuite Lévis, devis toiture Lévis, estimation toiture, prix couvreur, couvreur',
    ogImage: '/og/og-soumission-gratuite.jpg',
    ogImageAlt: 'Soumission gratuite à Lévis - Réponse garantie en 2h',
    jsonLdSchema: [breadcrumbSchema, serviceSchema, faqSchema],
  });

  return (
    <div className="font-inter min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <PourquoiNous />
        <ProcessTimeline />
        <Garanties />
        <TemoignagesRapides />
        <FAQ />
        <QuoteForm />
        <CTAFinal />
      </main>
      <Footer />
    </div>
  );
}